import React from 'react'
import ReadMoreButton from '../../../read-more-button'
import { PrincipalAppStoreButtons } from '../../../principal-app-store-buttons'
import { ImageSlider } from './image-slider'

export const AboutSection = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="row content">
          <div className="col-lg-6">
            <h2>Mobile and Web App for Milk Producer</h2>

            <h3>
              With our mobile app or web portal, your milk producers can do self-service to review or download test results, milk pickups, and
              download financial reports.
            </h3>

            <div>
              <PrincipalAppStoreButtons />
            </div>

            <ReadMoreButton url="/docs/posts/getting-started-with-principal" />
          </div>
          <div className="col-lg-6 pt-4 pt-lg-0">
            <ImageSlider />
          </div>
        </div>
      </div>
    </section>
  )
}
